import { AppUser, Claim, LoggedInUser } from '@web/csl-lib-models';
import { computed } from '@angular/core';
import { getClaim } from '@web/csl-lib-utils';
import { GlobalState } from '@web/csl-lib-store';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';

const initialState: GlobalState = {
  claims: [],
  isLoading: false,
  progBarLoadingCount: 0
};

export const GlobalStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    setLoading() {
      patchState(store, {
        progBarLoadingCount: store.progBarLoadingCount() + 1,
        isLoading: true
      });
    },
    unsetLoading() {
      patchState(store, {
        progBarLoadingCount: store.progBarLoadingCount() == 0 ? 0 : store.progBarLoadingCount() - 1,
        isLoading: false
      });
    },
    // resetLoading() {
    //   patchState(store, { progBarLoadingCount: 0 });
    // },
    setClaims(claims: Claim[]) {
      patchState(store, { claims: claims });
    },
    setOnboardingComplete(appUser: AppUser) {

      // Must create a new array to trigger the computed signal (loggedInUser) change detection
      const claims = [...store.claims()];

      // Update claims locally because they won't be sent from B2C until the next login
      const claimIndexObComplete = store.claims().findIndex((claim) => claim.claim === 'extension_IsOnboardingComplete');
      claims[claimIndexObComplete].value = 'true';

      const claimIndexRel = store.claims().findIndex((claim) => claim.claim === 'extension_Relationship');
      claims[claimIndexRel].value = appUser.relationship.toString();

      patchState(store, { claims: claims });
  }
  })),
  withComputed((state) => ({
    progBarIsLoading: computed(() => state.progBarLoadingCount() > 0),
    loggedInUser: computed(() =>
    {
      if(state.claims() == null || state.claims().length === 0) {
        return null;
      }

      const loggedInUser: LoggedInUser = {
        firstName: getClaim(state.claims(), 'given_name')?.value || '??',
        lastName: getClaim(state.claims(), 'family_name')?.value || '??',
        displayName: getClaim(state.claims(), 'name')?.value || '??',
        initials: `${getClaim(state.claims(), 'given_name')?.value?.charAt(0) || '?'}${getClaim(state.claims(), 'family_name')?.value?.charAt(0) || '?'}`,
        email: getClaim(state.claims(), 'emails')?.value[0] || '??',
        survivorLinkId: getClaim(state.claims(), 'extension_SurvivorLinkId')?.value.toUpperCase() || '??',
        b2cId: getClaim(state.claims(), 'oid')?.value || '??',
        isOnboardingComplete: getClaim(state.claims(), 'extension_IsOnboardingComplete')?.value?.toString().toLowerCase() === 'true',
        survivorLinkRelationship: parseInt(getClaim(state.claims(), 'extension_Relationship')?.value || '0'),
        isPfcUser: getClaim(state.claims(), 'idp')?.value === 'PFC'
      };

      const  clinicProfileClaimJson = getClaim(state.claims(), 'extension_ClinicStaffProfile')?.value;
      const clinicProfileClaim = clinicProfileClaimJson ? JSON.parse(clinicProfileClaimJson) : null;

      if(clinicProfileClaim) {
        loggedInUser.isClinicStaff = true;
        loggedInUser.clinicStaffProfile = {
          clinicId: clinicProfileClaim.clinicId,
          isMrrContact: clinicProfileClaim.isMedicalRecordContact,
          isPrimaryContact: clinicProfileClaim.isPrimaryContact,
        }
      }

      return loggedInUser;
    }),

  })),
);



